import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import styles from './playoffs.module.css';

import constants from '../../../constants';
import api from '../../../routes/api.js';
import utils from '../../../utils/utils.js';

import { useApiProvider } from '../../../providers/ApiProvider.js';
import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useLeagueTypeProvider } from '../../../providers/LeagueTypeProvider';

// 1240 is the width of the bracket so that sidebar open on a 1600px screen shows the full bracket
const bracket16MinWidth = 1290;
const bracket8MinWidth = 976;
const bracket4MinWidth = 700;
const championCellHeight = '(50px + 50px + 210px + 48px)';

const goToMatchup = (location, division, matchup, navigate, leagueType) => {
    // No click on bye. NO
    if (matchup[constants.awayTeamId] == constants.byeTeamId || matchup[constants.homeTeamId] == constants.byeTeamId) return
    
    if (matchup !== null) {navigate('/' + leagueType + '/matchup', { 
      replace: true,
      state: {
        selectedLocation: location,
        selectedDivision: division, 
        matchup: {
          matchupId: matchup[constants.matchupId],
          matchupDate: matchup[constants.date],
          homeClub: matchup[constants.homeClub],
          homeTeamName: matchup[constants.homeName].toUpperCase(),
          homeTeamId: matchup[constants.homeTeamId],
          awayClub: matchup[constants.awayClub],
          awayTeamName: matchup[constants.awayName].toUpperCase(),
          awayTeamId: matchup[constants.awayTeamId],
        }
      }
    })}
}

const Matchup = ({location, division, matchup, connectorSide, height}) => {

  const navigate = useNavigate();
  const { leagueType } = useLeagueTypeProvider();

    return (
      matchup ?
      <div 
        className={`${styles.MatchupContainer} ${connectorSide}`} 
        style={{'--height': height}}
        onClick={() => {goToMatchup(location, division, matchup, navigate, leagueType)}}>
        <div 
          className={matchup[constants.endResult] == constants.away ? styles.TeamContainerWinner : styles.TeamContainer} 
          style={{borderBottom: `1px solid ${matchup[constants.endResult] == constants.away ? constants.colors.cplYellow : constants.colors.cplNavy}`}}>
          <div className={matchup[constants.endResult] == constants.away ? styles.TeamLogoWinner : styles.TeamLogo}>
            {matchup[constants.awayTeamId] != constants.byeTeamId ? 
            <>
              <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.awayClub][constants.logo]}.png`}/> {`${matchup[constants.awayName]} (${matchup[constants.awayPodRanking]})`}
            </> 
            : "BYE"}
          </div>
          <div className={matchup[constants.endResult] == constants.away ? styles.ScoreWinner : styles.Score}>
            {matchup[constants.awayTeamId] != constants.byeTeamId ? matchup[constants.awayWins] : "-"}
          </div>
        </div>
        <div className={matchup[constants.endResult] == constants.home ? styles.TeamContainerWinner : styles.TeamContainer}>
          <div className={matchup[constants.endResult] == constants.home ? styles.TeamLogoWinner : styles.TeamLogo}>
            {matchup[constants.homeTeamId] != constants.byeTeamId ? 
            <>
              <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.homeClub][constants.logo]}.png`}/> {`${matchup[constants.homeName]} (${matchup[constants.homePodRanking]})`}
            </> 
            : "BYE"}
          </div>
          <div className={matchup[constants.endResult] == constants.home ? styles.ScoreWinner : styles.Score}>
            {matchup[constants.homeTeamId] != constants.byeTeamId ? matchup[constants.homeWins] : "-"}
          </div>
        </div>
      </div> : 
      <div 
        className={`${styles.MatchupContainer} ${connectorSide}`} 
        style={{'--height': height}}>
        <div 
          className={styles.TeamContainer} 
          style={{borderBottom: `1px solid ${constants.colors.cplNavy}`}}>
          <div className={styles.TeamLogo}>
            {}
          </div>
          <div className={styles.Score}>
            {}
          </div>
        </div>
        <div className={styles.TeamContainer}>
          <div className={styles.TeamLogo}>
            {}
          </div>
          <div className={styles.Score}>
            {}
          </div>
        </div>
      </div>
  );
}

const Semis = ({location, division, matchup, height}) => {
  const navigate = useNavigate();
  return(
    matchup ? 
    <div className={styles.SemisCell} style={{height: height}}>
      <div 
        className={matchup[constants.endResult] == constants.away ? styles.SemisContainerWinner : styles.SemisContainer} 
        style={{borderBottom: `1px solid ${matchup[constants.endResult] == constants.away ? constants.colors.cplYellow : constants.colors.cplNavy}`}}
        onClick={() => {goToMatchup(location, division, matchup, navigate)}}>
        <div className={matchup[constants.endResult] == constants.away ? styles.TeamLogoWinner : styles.TeamLogo}>
          {matchup[constants.awayTeamId] != constants.byeTeamId ? 
            <>
              <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.awayClub][constants.logo]}.png`}/> {`${matchup[constants.awayName]} (${matchup[constants.awayPodRanking]})`}
            </> 
            : "BYE"}
        </div>
        <div className={matchup[constants.endResult] == constants.away ? styles.ScoreWinner : styles.Score}>
          {matchup[constants.awayTeamId] != constants.byeTeamId ? matchup[constants.awayWins] : "-"}
        </div>
      </div>

      <div 
        className={matchup[constants.endResult] == constants.home ? styles.SemisContainerWinner : styles.SemisContainer} 
        onClick={() => {goToMatchup(location, division, matchup, navigate)}}>
        <div className={matchup[constants.endResult] == constants.home ? styles.TeamLogoWinner : styles.TeamLogo}>
          {matchup[constants.homeTeamId] != constants.byeTeamId ? 
            <>
              <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.homeClub][constants.logo]}.png`}/> {`${matchup[constants.homeName]} (${matchup[constants.homePodRanking]})`}
            </> 
            : "BYE"}
        </div>
        <div className={matchup[constants.endResult] == constants.home ? styles.ScoreWinner : styles.Score}>
          {matchup[constants.homeTeamId] != constants.byeTeamId ? matchup[constants.homeWins] : "-"}
        </div>
      </div>
    </div> :
    <div className={styles.SemisCell} style={{height: height}}>
      <div 
        className={styles.SemisContainer} 
        style={{borderBottom: `1px solid ${constants.colors.cplNavy}`}}>
        <div className={styles.TeamLogo}>
          {}
        </div>
        <div className={styles.Score}>
          {}
        </div>
      </div>

      <div 
        className={styles.SemisContainer} >
        <div className={styles.TeamLogo}>
          {}
        </div>
        <div className={styles.Score}>
          {}
        </div>
      </div>
    </div>
  );
}

const Championship = ({location, division, matchup}) => {
  const navigate = useNavigate();
  return(
    matchup ? 
    <div className={styles.ChampionCell}>
      <div 
        className={matchup[constants.endResult] == constants.away ? styles.ChampionshipContainerWinner : styles.ChampionshipContainer} 
        style={{borderBottom: `2px solid ${matchup[constants.endResult] == constants.away ? constants.colors.cplYellow : constants.colors.cplNavy}`}}
        onClick={() => {goToMatchup(location, division, matchup, navigate)}}>
        <div className={matchup[constants.endResult] == constants.away ? styles.TeamLogoWinner : styles.TeamLogo}>
          <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.awayClub][constants.logo]}.png`}/> {`${matchup[constants.awayName]} (${matchup[constants.awayPodRanking]})`} 
        </div>
        <div className={matchup[constants.endResult] == constants.away ? styles.ScoreWinner : styles.Score}>
          {matchup[constants.awayWins]}
        </div>
      </div>

      {matchup[constants.endResult] == null ? 
      <div className={styles.CplLogo} ><img src='/icons/cpl-trophy.svg'/></div>
      :
      <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
        <img 
          style={{height: '80px', width: '80px'}}
          src={`/logos/${matchup[constants.endResult] == "away" ? matchup[constants.awayClub][constants.logo] : matchup[constants.homeClub][constants.logo]}.png`}/>
        <div 
          className={styles.ChampionText}>
            {`CPL ${location[constants.locationName]} ${division[constants.divisionName]} Champion!`}
            </div>
      </div>}

      <div 
        className={matchup[constants.endResult] == constants.home ? styles.ChampionshipContainerWinner : styles.ChampionshipContainer}
        onClick={() => {goToMatchup(location, division, matchup, navigate)}}>
        <div className={matchup[constants.endResult] == constants.home ? styles.TeamLogoWinner : styles.TeamLogo}>
          <img style={{height: '24px', width: '24px', marginRight: '2px'}} src={`/logos/${matchup[constants.homeClub][constants.logo]}.png`}/> {`${matchup[constants.homeName]} (${matchup[constants.homePodRanking]})`} 
        </div>
        <div className={matchup[constants.endResult] == constants.home ? styles.ScoreWinner : styles.Score}>
          {matchup[constants.homeWins]}
        </div>
      </div>
    </div> :
    <div className={styles.ChampionCell}>
      <div 
        className={styles.ChampionshipContainer} 
        style={{borderBottom: `1px solid ${constants.colors.cplNavy}`}}>
        <div className={styles.TeamLogo}>
          {}
        </div>
        <div className={styles.Score}>
          {}
        </div>
      </div>

      <div className={styles.CplLogo} ><img src='/icons/cpl-trophy.svg'/></div>

      <div 
        className={styles.ChampionshipContainer}>
        <div className={styles.TeamLogo}>
          {} 
        </div>
        <div className={styles.Score}>
          {}
        </div>
      </div>
    </div>
  )

}

const Bracket16 = ({location, division, rounds, width}) => {
  // Height of one matchup + the gap
  const height = '(80px + 32px)';

  return(
    // Width of the BracketContainer >= windowwidth - sidebar width. Ensures no flexing on 1600px screen
    width >= bracket16MinWidth ? 
    <div className={styles.BracketGrid16}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[0]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[0]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        {/* On bigger screens, the left side is the first half of the array, otherwise its the full round*/}
        {rounds.week1.slice(0, 4).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightAfter} height={height}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week2.slice(0, 2).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightMiddle} height={height}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week3.slice(0, 1).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightBefore} height={height}/>
        })}
      </div>

      <Championship location={location} division={division} matchup={rounds.week4[0]}/>

      <div className={styles.RoundColumn}>
        {rounds.week3.slice(1).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.LeftBefore} height={height}/>
        })}
      </div>
      {rounds.week2.length > 0 && <div className={styles.RoundColumn}>
        {rounds.week2.slice(2).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.LeftMiddle} height={height}/>
        })}
      </div>}
      {rounds.week1.length > 0 && <div className={styles.RoundColumn}>
        {rounds.week1.slice(4).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.LeftAfter} height={height}/>
        })}
      </div>}
    </div> : 
    <div className={styles.BracketGrid16Flex}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[0]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        {/* On bigger screens, the left side is the first half of the array, otherwise its the full round*/}
        {rounds.week1.map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightAfter} height={height}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week2.map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightMiddle} height={height}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week3.map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightBefore} height={height}/>
        })}
      </div>

      <Championship location={location} division={division} matchup={rounds.week4[0]}/>
    </div>
  )
}

const Bracket8 = ({location, division, rounds, width}) => {
  // Height of one matchup + the gap
  const maxHeight = '(114px + 32px)';
  const minHeight = '(80px + 32px)';

  return(
    // Width of the BracketContainer >= windowwidth - sidebar width. Ensures no flexing on 1600px screen
    width >= bracket8MinWidth ? 
    <div className={styles.BracketGrid8}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        {rounds.week1.slice(0, 2).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightAfter} height={maxHeight}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week2.slice(0, 1).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightBefore} height={maxHeight}/>
        })}
      </div>

      <Championship location={location} division={division} matchup={rounds.week3[0]}/>

      <div className={styles.RoundColumn}>
        {rounds.week2.slice(1).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.LeftBefore} height={maxHeight}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week1.slice(2).map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.LeftAfter} height={maxHeight}/>
        })}
      </div>
    </div> : 
    <div className={styles.BracketGrid8Flex}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[1]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        {rounds.week1.map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightAfter} height={minHeight}/>
        })}
      </div>
      <div className={styles.RoundColumn}>
        {rounds.week2.map((m) => {
          return <Matchup location={location} division={division} matchup={m} connectorSide={styles.RightBefore} height={minHeight}/>
        })}
      </div>

      <Championship location={location} division={division} matchup={rounds.week3[0]}/>
    </div>
  )
}

const Bracket4 = ({location, division, rounds, width}) => {
  return(
    width >= bracket4MinWidth ? 
    <div className={styles.BracketGrid4}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        <Semis location={location} division={division} matchup={rounds.week1[0]} height={`calc(${championCellHeight} * 2)`}/>
      </div>

      <Championship location={location} division={division} matchup={rounds.week2[0]}/>

      <div className={styles.RoundColumn}>
          <Semis location={location} division={division} matchup={rounds.week1[1]} height={`calc(${championCellHeight} * 2)`}/>
      </div>
    </div> :
    <div className={styles.BracketGrid4Flex}>
      {/* Title row*/}
      <div className={styles.HeaderCell}>{constants.playoffRounds[2]}</div>
      <div className={styles.HeaderCell}>{constants.playoffRounds[3]}</div>

      {/* Bracket row*/}
      <div className={styles.RoundColumn}>
        {rounds.week1.map((m) => {
          return <Semis location={location} division={division} matchup={m} height={`calc(${championCellHeight} / 2)`}/>
        })}
      </div>

      <Championship location={location} division={division} matchup={rounds.week2[0]}/>
    </div>
  )
}

const Playoffs = ({selectedLocation, selectedDivision, setSelectedMenuItem}) => {
  const { setIsSidebarShowing } = useSidebarProvider();
  const { setDialog, isLoading, setIsLoading, LoadingSpinner} = useApiProvider();
  const { leagueType } = useLeagueTypeProvider();

  const bracketRef = useRef(null);

  const [width, setWidth] = useState();
  const [rounds, setRounds] = useState(null);

  useEffect(() => {
    if (isLoading) return; // Wait for data from App.js
    
    const getMatches = async () => {
      setIsLoading(true);
      try {
        const baseUrl = utils.getBaseUrl(leagueType);

        const playoffResponse = await api.fetch(baseUrl, constants.uri.matchups(selectedDivision[constants.divisionId]), "?playoffs=true");
        if (playoffResponse.hasOwnProperty('errors')) throw playoffResponse;
        
        const newRounds = {
          week1: [],
          week2: [],
          week3: [],
          week4: []
        };

        if (playoffResponse[constants.values].length > 0) {
          playoffResponse[constants.values].forEach( (m) => {
           newRounds[`week${m[constants.weekNumber]}`].push(m);
          })
        }

        setRounds(newRounds);
        setIsLoading(false);
      }
      catch(err) {
        console.error(err);
        setDialog({
          title: err.title ? err.title : constants.messages.errorMessage, 
          code: err.code ? err.code : "N/A", 
          message: err.message, 
          isError: true});
        setIsLoading(false);
      }
    }

    getMatches();
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem(constants.sidebarItems[4]);

    // Use the width of the bracket to determine when to "flex" the columns
    const handleResize = (entries) => {
      if (entries[0]) {
        setWidth(entries[0].contentRect.width);
      }
    };
    const resizeObserver = new ResizeObserver(handleResize);
    if (bracketRef.current) {
      // Set initial width
      setWidth(bracketRef.current.offsetWidth);
      // Start observing
      resizeObserver.observe(bracketRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };

    
  }, [selectedDivision]);

  //Determine which bracket to render
  let bracket;

  if (rounds != null) {
    if (rounds.week1.length == 8) {
      if (rounds.week1.length == 0) rounds.week1 = Array.from({length: 8}, () => null);
      if (rounds.week2.length == 0) rounds.week2 = Array.from({length: 4}, () => null);
      if (rounds.week3.length == 0) rounds.week3 = Array.from({length: 2}, () => null);
      if (rounds.week4.length == 0) rounds.week4 = Array.from({length: 1}, () => null);

      bracket = <Bracket16 location={selectedLocation} division={selectedDivision} rounds={rounds} width={width}/>
    }
    else if (rounds.week1.length == 4) {
      if (rounds.week1.length == 0) rounds.week1 = Array.from({length: 4}, () => null);
      if (rounds.week2.length == 0) rounds.week2 = Array.from({length: 2}, () => null);
      if (rounds.week3.length == 0) rounds.week3 = Array.from({length: 1}, () => null);

      bracket = <Bracket8 location={selectedLocation} division={selectedDivision} rounds={rounds} width={width}/>
    }
    else if (rounds.week1.length == 2 ) {
      if (rounds.week1.length == 0) rounds.week1 = Array.from({length: 2}, () => null);
      if (rounds.week2.length == 0) rounds.week2 = Array.from({length: 1}, () => null);
      
      bracket = <Bracket4 location={selectedLocation} division={selectedDivision} rounds={rounds} width={width}/>
    }
    else {
      if (rounds.week1.length == 0) rounds.week1 = Array.from({length: 8}, () => null);
      if (rounds.week2.length == 0) rounds.week2 = Array.from({length: 4}, () => null);
      if (rounds.week3.length == 0) rounds.week3 = Array.from({length: 2}, () => null);
      if (rounds.week4.length == 0) rounds.week4 = Array.from({length: 1}, () => null);

      bracket = <Bracket16 location={selectedLocation} division={selectedDivision} rounds={rounds} width={width}/>
    }
  }

  return (

    <div className={styles.Playoffs}>
      <div className={styles.Header}>
        <div className={styles.Title}>{constants.titles.playoffs}</div>
        <div className={styles.SubTitle}> {`${selectedLocation[constants.locationName] ? selectedLocation[constants.locationName] : "location"} ${selectedDivision[constants.divisionName] ? selectedDivision[constants.divisionName] : "division"}`}</div>
      </div>

      <hr className={styles.Spacer}/>

      {/* Each "column" in the grid is the title, and the matches for that round. Each round content is a vertical flex box.*/}
      {rounds != null && <div ref={bracketRef} className={styles.BracketContainer}>
        {bracket}
      </div>}

      
    </div>

  )
}

export default Playoffs;